import React, { useState } from "react";
import { CustomImgPreviewModal } from "./Modals";

const CustomImageCard = ({ src, alt, width, height, imagePreview }) => {
  const [loaded, setLoaded] = useState(false);
  const [imgSrc, setImgSrc] = useState("");
  const [imgZoom, setImgZoom] = useState(false);

  const handleViewPreview = (img) => {
    setImgZoom(true);
    setImgSrc(img);
  };

  return (
    <div
      className="fog_custom_image_wrapper"
      style={{
        width,
        height: height || "75px",
        position: "relative",
        margin: "0px auto",
      }}
    >
      {!loaded && <div className="fog_custom_image_loading" />}
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading="lazy"
        style={{
          height: "100%",
          objectFit: "cover",
          cursor: imagePreview ? "pointer" : "default",
        }}
        onClick={() => imagePreview && handleViewPreview(src)}
        onLoad={() => setLoaded(true)}
      />
      {imgZoom && (
        <CustomImgPreviewModal
          show={imgZoom}
          imgSrc={imgSrc}
          onHide={() => setImgZoom(!imgZoom)}
        />
      )}
    </div>
  );
};

export default React.memo(CustomImageCard);
